/** Design tokens — dense desktop-software admin chrome */
export const tokens = {
  fontFamily:
    '"Segoe UI", "Nunito", "Plus Jakarta Sans", system-ui, sans-serif',
  /** Narrower nav — software pane, not marketing sidebar */
  drawerWidth: 212,
  /** Compact title bar height */
  shellHeaderHeight: 44,
  /** Always use these as px strings in `sx` — numeric values multiply MUI `shape.borderRadius`. */
  radius: {
    none: "0",
    sm: "3px",
    md: "4px",
    lg: "4px",
    xl: "6px",
  },
  colors: {
    primary: {
      main: "#FE9F43",
      light: "#FFB366",
      dark: "#E88A2E",
      contrast: "#FFFFFF",
    },
    secondary: {
      main: "#092C4C",
      light: "#1E4A6E",
      dark: "#061E33",
      contrast: "#FFFFFF",
    },
    neutral: {
      50: "#F4F5F7",
      100: "#EBEDF0",
      200: "#E0E3E8",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
    sidebar: {
      bg: "#FFFFFF",
      bgHover: "#F4F5F7",
      bgActive: "rgba(254, 159, 67, 0.12)",
      border: "#E0E3E8",
      text: "#6B7280",
      textActive: "#092C4C",
      accent: "#FE9F43",
      section: "#9CA3AF",
    },
    success: { main: "#28C76F", light: "#E8F8EF" },
    warning: { main: "#FF9F43", light: "#FFF4E8" },
    error: { main: "#EA5455", light: "#FCEAEA" },
    info: { main: "#00CFE8", light: "#E5FAFC" },
    /** DreamsPOS dashboard KPI card backgrounds */
    dashOrange: "#FE9F43",
    dashNavy: "#092C4C",
    dashTeal: "#28C76F",
    dashBlue: "#1B84FF",
    dashPurple: "#7367F0",
    dashMint: "#00CFE8",
    dashPeach: "#FFBC80",
  },
} as const;
